<template>
  <base-modal
    id="imageCrop"
    :show="show"
    :title="editorTitle"
    @closed="resetComponent"
  >
    <image-editor
      ref="imageEditor"
      :initial-step="initialStep"
      :pre-filled-image="preFilledImage"
      :step="step"
      :is-loading="isLoading"
      @change-step="onStepChanged"
      @close-editor="$emit('close-editor', $event)"
      @change-avatar="$emit('change-avatar', $event)"
      @delete-avatar="$emit('delete-avatar', $event)"
    />
    <template v-slot:footer>
      <span
        class="mr-auto delete-avatar__btn"
        @click="$emit('delete-avatar')"
      >Delete picture</span>

      <base-button
        @click="checkAction()"
      >
        {{ secondaryActionText }}
      </base-button>
      <base-button
        inverse
        :disabled="step === 0"
        @click="upload"
      >
        <span v-if="!isLoading">
          Save
        </span>
        <span v-else>
          <base-loading :show="true" />
        </span>
      </base-button>
    </template>
  </base-modal>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'AvatarEditor',
  props: {
    initialStep: {
      type: Number,
      default: 0, // 0: uploader | 1: Crop
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    preFilledImage: {
      type: String,
      default: '',
    },
    editorTitle: {
      type: String,
      default: 'Edit Profile Picture',
    },
    secondaryActionText: {
      type: String,
      default: 'Change Image',
    },
  },
  data() {
    return {
      show: false,
      step: 0, // 0: uploader | 1: Crop
    };
  },
  watch: {
    initialStep: {
      handler(value) {
        this.step = value;
      },
      immediate: true,
    },
  },
  mounted() {
    EventBus.$on('avatar-editor--close', () => {
      this.close();
    });
    EventBus.$on('avatar-editor--open', () => {
      this.close();
    });
  },
  methods: {
    onStepChanged(newStep) {
      this.step = newStep;
      this.$emit('change-step', newStep);
    },
    open() {
      this.show = true;
    },
    close() {
      this.$emit('close-editor');
      this.show = false;
    },
    resetComponent() {
      this.show = false;
      this.$emit('close-editor');
      this.$nextTick().then(() => this.$refs.imageEditor?.resetComponent());
    },
    checkAction() {
      if (this.secondaryActionText === 'Change Image') {
        this.$nextTick().then(() => this.$refs.imageEditor.selectImage());
      }
      if (this.secondaryActionText === 'Cancel Image') {
        return this.$emit('cancel-selection');
      }
      return '';
    },
    upload() {
      this.$nextTick().then(() => {
        this.$refs.imageEditor.upload();
      });
    },
  },
};
</script>
<style lang="scss"
  scoped>
#imageCrop::v-deep .modal-dialog{
  min-width: 800px !important;
  @media (min-width: 576px){
    max-width: 800px !important;
  }
  .modal-header .close{
    padding: 1rem 1rem !important;
    margin: -1rem -1rem -1rem auto !important;
  }
}
.delete-avatar__btn{
  //color: $gray-light-2;
  color: #333333;
  font-size: 0.875rem;
  cursor: pointer;
}
</style>
